export const name = 'Fit Hier';
export const baseUrl = 'https://fithier.com';
export const generalMail = 'info@fithier.com';
export const logoUrl = 'https://fithier.com/img/logo/fit-hier-icon-center-dark@2x.png';
